import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DomPurify from 'dompurify';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames, LocalStorageItems } from '../../../models/Common';
import { useDateLocalization } from '../../../hooks/useDateLocalization';

export const ServiceSuspended = () => {
  const { t } = useTranslation();
  const { formatDate } = useDateLocalization();
  const history = useHistory();
  const sanitizer = DomPurify.sanitize;

  const serviceName = localStorage.getItem(LocalStorageItems.ServiceName);
  const toDate = localStorage.getItem(LocalStorageItems.ToDate) || '';
  const formattedToDate = toDate
    ? formatDate(toDate, {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        locale: 'uk',
      })
    : '';

  const navigateToMainPage = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  const navigateToPaymentHistoryPage = () => {
    history.push(GlobalRouteNames.PaymentHistory);
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem(LocalStorageItems.ServiceName);
      localStorage.removeItem(LocalStorageItems.FromDate);
      localStorage.removeItem(LocalStorageItems.ToDate);
    };
  }, []);

  if (!serviceName) {
    history.push(GlobalRouteNames.HomePage);
  }

  return (
    <div className="success-container">
      <h1>{t('success.theServiceHasBeenSuccessfullyActivated')}</h1>
      <p
        className="success-text"
        dangerouslySetInnerHTML={{
          __html: sanitizer(t('success.yourServiceSuspend', { to: formattedToDate })),
        }}
      />
      <div className="success-container__buttons-group">
        <CustomMUIButton
          label={t('buttons.toMain')}
          handleClick={navigateToMainPage}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('buttons.yourPayments')}
          handleClick={navigateToPaymentHistoryPage}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
